<template>
  <div id="app">
    <!-- 暂不明确控制管理页面和首页的对立条件 -->
    <template v-if="this.$route.fullPath.substring(1, 6)=='admin'">
      <router-view></router-view>
    </template>
    <template v-else-if="this.$route.fullPath.substring(1, 11)=='iaic2019en'">
      <en-header></en-header>
      <router-view></router-view>
      <en-footer></en-footer>
      <!-- <en-elevator v-if="btnFlag" class="nav"></en-elevator> -->
      <global-nav v-if="btnFlag" class="nav"></global-nav>
    </template>
    <template v-else>
      <mod-header></mod-header>
      <router-view></router-view>
      <!-- <router-view v-if='!$route.meta.keepAlive'></router-view> -->
      <mod-footer></mod-footer>
      <!-- 返回头部组件 -->
      <global-nav v-if="btnFlag" class="nav"></global-nav>
    </template>
  </div>
</template>
<script>
import * as gettersType from '@/store/getters/type';
import modHeader from '@/pages/views/header/header';
import modFooter from '@/pages/views/footer/footer';
import enHeader from '@/pages/enViews/header/header';
import enFooter from '@/pages/enViews/footer/footer';
// import globalNav from './common/area/right-nav';
import globalNav from './common/component/BackToTop/index';
import enElevator from './common/area/enElevator';

export default {
  data() {
    return {
      btnFlag: false,
      gettersType,
      scrollTop: 0
    };
  },
  created() { },
  components: {
    modHeader,
    modFooter,
    globalNav,
    enHeader,
    enFooter,
    enElevator
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop);
  },
  methods: {
    scrollToTop() {
      // 为了计算距离顶部的高度，当高度大于240显示回顶部图标，小于240则隐藏
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 240) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  }
};
</script>
<style >
/* 引入 quill-editor字体 */
@import './assets/fonts/quill';
</style>
<style lang="stylus" scoped>
@import './assets/stylus/color';

#app {
  height: 100%;
  width: 100%;
}

.nav {
  // position: fixed;
  // bottom: 100px;
  // right: 100px;
  // z-index: 90;
}
</style>



// WEBPACK FOOTER //
// src/App.vue